export const DEVICE_DISTRIBUTION_ENDPOINT = "/widgetApi/IndustryAnalysisOverview/EngagementVisits/PieChart";
